import Image from 'app/Components/Shared/Image/image';
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { DomainMarketCode } from "../../../utilities/domain/domainConstants";
import CollapseButton from "../../../utilities/CollapseButton/CollapseButton";
import {
  workOrderType,
  notes,
  selfPickUpOrderStatus,
  SapShopCode,
} from "../../Page/TransactionSummaryPage/Shared/Constants";
import { checkSectionValid } from "../../Page/TransactionSummaryPage/Shared/HelperFunctions";
import DateLogo from "./assets/date.svg";
import TimeLogo from "./assets/time.svg";
import { transactionType } from "../../Page/TransactionSummaryPage/Shared/Constants";
import StatusDeliveryUpdatedLogo from "./assets/statusDeliveryUpdated.svg";
import Config from "../../../Config";

const DeliveryMethod = ({ data, context, deliveryMethod, dealType }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [allDeliveries, setDeliveries] = useState(<div />);
  const showComponent = checkSectionValid(deliveryMethod);
  const marketCode = useSelector((state) => state.domain.MarketCode);

  let cardTitle =
    data.deliveryMethodProvideTopic.value === ""
      ? "אופן אספקה"
      : data.deliveryMethodProvideTopic.value;
  if (dealType === transactionType.Disconnect) {
    cardTitle =
      data.deliveryMethodDisconnectTopic.value === ""
        ? "איסוף הציוד"
        : data.deliveryMethodDisconnectTopic.value;
  }

  useEffect(() => {
    if (showComponent)
      setDeliveries(setDetails(deliveryMethod.deliveriesInfo, data, dealType, marketCode));
  }, [deliveryMethod, marketCode]);

  return showComponent ? (
    <div className="block-frame p-2">
      <CollapseButton
        cardTitle={cardTitle}
        setIsOpen={setIsOpen}
        isOpen={isOpen}
      />
      {isOpen && <div className="block-frame__container">{allDeliveries}</div>}
    </div>
  ) : null;
};

function setTime(startDate, endDate) {
  let result = "";

  const startTimeWithSecs = startDate.split(" ")[1].split(":");
  const endTimeWithSecs = endDate.split(" ")[1].split(":");
  result =
    endTimeWithSecs[0] +
    ":" +
    endTimeWithSecs[1] +
    " - " +
    startTimeWithSecs[0] +
    ":" +
    startTimeWithSecs[1];

  return result;
}

function setDate(date) {
  return (
    date.split("/")[1] + "/" + date.split("/")[0] + "/" + date.split("/")[2]
  );
}

function setDetails(deliveriesInfo, data, dealType, marketCode) {
  const isGolan = marketCode === DomainMarketCode.GOLAN;
  const selfPickUpDeliveryArr = deliveriesInfo.filter(
    (delivery) => delivery.workOrderType === workOrderType.SelfPickUp,
  );
  const isDeliverySelfPickUp = selfPickUpDeliveryArr.length > 0;
  const cellcomCentersLink = getUrl(data.deliveryMethodOtherCentersLink.value);
  const scheduleDifferentTimeLink = getUrl(
    data.deliveryMethodChangeDateLink.value,
  );
  const scheduleDifferentTimeForDeliveryLink = getUrl(
    data.deliveryMethodChangeDateForDeliveryLink.value,
  );

  let deliveries = deliveriesInfo.map((delivery, idx) => {
    if (delivery.workOrderType !== workOrderType.SelfPickUp) {
      let time = "";
      let date = "";

      if (delivery.startDate) {
        time = setTime(delivery.startDate, delivery.endDate);
        date = setDate(delivery.startDate.split(" ")[0]);
      }
      /* all deliveries are sorted by cancelled and then all the rest (sort done in backend) */
      const isWorkOrderCancelled =
        delivery.workOrderStatusDetails?.code.includes("cancelled") ||
        delivery.workOrderStatusDetails?.code.includes("canceled");

      let gridLayoutStructureStyle = "";
      if (isWorkOrderCancelled)
        gridLayoutStructureStyle += " delivery-method__delivery-info--3";

      if (delivery.bezeqTechnicianType === "3")
        gridLayoutStructureStyle += " delivery-method__delivery-info--2";

      return (
        <div
          className={
            "delivery-method__delivery-info" + gridLayoutStructureStyle
          }
          key={idx.toString() + delivery.workOrderType}
        >
          <div
            className={
              "delivery-method__status delivery-method__status" +
              (isWorkOrderCancelled ? "--1" : "--2")
            }
          >
            <label>{delivery.workOrderStatusDetails?.description}</label>
          </div>
          <div
            className={
              "delivery-method__column delivery-method__column--1 " +
              (isWorkOrderCancelled ? "cancelled" : "")
            }
          >
            <label className="delivery-method__label">
              {delivery.workOrderType}
            </label>
            <span className="delivery-method__address">
              {" "}
              {delivery.address}
            </span>
          </div>
          {delivery.startDate && (
            <React.Fragment>
              <div
                className={
                  "delivery-method__column delivery-method__column--2 " +
                  (isWorkOrderCancelled ? "cancelled" : "")
                }
              >
                <div className="delivery-method__holder">
                  <Image className="delivery-method__icon"
                    src={DateLogo}
                    alt="" />
                  <span>
                    {delivery.bezeqTechnicianType === "3"
                      ? "לטיפול עד לתאריך: " + date
                      : date}
                  </span>
                </div>
                {delivery.bezeqTechnicianType !== "3" && (
                  <div className="delivery-method__holder">
                    <Image className="delivery-method__icon"
                      src={TimeLogo}
                      alt="" />
                    <span>{time}</span>
                  </div>
                )}
              </div>
              {delivery.bezeqTechnicianType !== "3" &&
                delivery.isAllowedToChangeTechVisitDate && (
                  <div className="delivery-method__column delivery-method__column--3">
                    <a
                      onClick={() =>
                        window.open(
                          delivery.workOrderType === "שליחות"
                            ? scheduleDifferentTimeForDeliveryLink
                            : scheduleDifferentTimeLink,
                          "_blank",
                        )
                      }
                      className="delivery-method__different-time"
                    >
                      לתיאום זמן אחר {">>"}
                    </a>
                  </div>
                )}
            </React.Fragment>
          )}
        </div>
      );
    }
  });

  deliveries = deliveries.filter((delivery) => delivery !== undefined);
  const selfPickUpTitle =
    dealType === transactionType.Disconnect
      ? "החזרה עצמית"
      : isGolan ? "איסוף עצמי ממשווקים מורשים" : "איסוף עצמי ממרכז השירות";
  let selfPickUpMsg = "";

  if (isDeliverySelfPickUp) {
    selfPickUpMsg =
      dealType !== transactionType.Disconnect
        ? setSelfPickUpMsg(selfPickUpDeliveryArr[0], isGolan)
        : "צירפנו עבורך את רשימת מרכזי השירות ושעות הפעילות אליהם ניתן להגיע ולהחזיר את הציוד";
  }

  return (
    <React.Fragment>
      {deliveries.length > 0 && (
        <React.Fragment>
          <label className="block-frame__sub-title">מתי נגיע ולאן?</label>
          <hr />
          <div className="delivery-method__deliveries-holder">{deliveries}</div>
          {adultNeedToBeAtHomeMsg(deliveriesInfo, data)}
          {displaySmsSentNotification(deliveriesInfo)}
        </React.Fragment>
      )}
      {isDeliverySelfPickUp && (
        <React.Fragment>
          <label
            className={
              "block-frame__sub-title " +
              (deliveries.length > 0 ? "delivery-method__two-sections" : "")
            }
          >
            {selfPickUpTitle}
          </label>
          <hr />
          <label className="delivery-method__label">{selfPickUpMsg}</label>
          {selfPickUpDeliveryArr[0].sapShopCode !== SapShopCode.SelfPickUp && (
            <a
              className="delivery-method__cellcom-centers-link"
              onClick={() => window.open(cellcomCentersLink, "_blank")}
            >
              {isGolan ? "צפייה בכל המשווקים המורשים" : "צפייה בכל מרכזי השירות"}
            </a>
          )}
        </React.Fragment>
      )}
    </React.Fragment>
  );
}

function setSelfPickUpMsg({
  workOrderStatusDetails,
  sapShopName,
  sapShopCode,
}, isGolan) {
  let res;

  const waitingMsg = isGolan
    ? "המוצרים שהזמנת ממתינים לך באחד מהמשווקים המורשים של גולן"
    : `המוצרים שהזמנת ממתינים לך במרכז שירות ${window.Config.brand_Name_HE} - ` + sapShopName;

  switch (workOrderStatusDetails?.code) {
    case selfPickUpOrderStatus.readyForDelivery:
      res = waitingMsg;
      break;
    case selfPickUpOrderStatus.create:
      res = waitingMsg;
      break;
    case selfPickUpOrderStatus.salesForceEndActivity:
      res = `הזמנה נאספה ממרכז שירות ${window.Config.brand_Name_HE} - ` + sapShopName;
      break;
    default:
      res = "";
  }
  /**
   */
  if (sapShopCode === SapShopCode.SelfPickUp) {
    res = `המוצרים שהזמנת יסופקו לך באמצעות נציג מטעם קבוצת ${window.Config.brand_Name_HE}`;
  }
  return res;
}

function adultNeedToBeAtHomeMsg(deliveries, data) {
  const isAdultNeeded =
    deliveries.filter(
      (delivery) =>
        delivery.workOrderType.toLowerCase() === workOrderType.CellcomTech ||
        delivery.workOrderType.toLowerCase() === workOrderType.Technician ||
        delivery.workOrderType.toLowerCase() === workOrderType.Delivery ||
        delivery.workOrderType.toLowerCase() === workOrderType.BezeqTechnician,
    ).length > 0;

  const message =
    data.deliveryMethodMessage.value === ""
      ? notes.Delivery
      : data.deliveryMethodMessage.value;


  return isAdultNeeded ? (
    <p className="delivery-method__note">{message}</p>
  ) : (
    ""
  );
}
function displaySmsSentNotification(deliveries) {
  const isSmsSentAfterInstallation =  deliveries.filter(
      (delivery) =>
          delivery.isSmsSentAfterInstallation
  ).length > 0;

  return isSmsSentAfterInstallation ? (
      <p className="delivery-method__noteSms">* לאחר השלמת ההתקנה תשלח הודעת SMS עם מועד אספקת המוצרים שרכשת</p>
  ) : (
      ""
  );
}
function getUrl(url) {
  let res = "";

  if (url !== null && url !== "") {
    try {
      res = new URL(url);
    } catch (e) {
      console.log(`getUrl ==> ${e}`);
      res = Config.staticWebSiteUrl + url;
    }
  }


  return res;
}

export default DeliveryMethod;
